/**
 * Session token access (SRP: single place for localStorage user shape).
 */
export function getStoredOrganizationId() {
  try {
    const raw = localStorage.getItem('user');
    if (!raw) return '';
    const parsed = JSON.parse(raw);
    return parsed?.user?.activeOrganizationId || parsed?.activeOrganizationId || '';
  } catch {
    return '';
  }
}

export function getStoredAuthToken() {
  try {
    const raw = localStorage.getItem('user');
    if (!raw) return '';
    const parsed = JSON.parse(raw);
    return parsed?.token || parsed?.user?.token || '';
  } catch {
    return '';
  }
}
